import {AbstractProvider} from "./AbstractProvider";
import {ColumnSize, DragDropConfig, IconView, TableConfig} from "../model/ColumnConfig";
import {ViewContainerRef} from "@angular/core";
import {AurDragDropManager} from "../drag-drop/aur-drag-drop.manager";
import { isFeatureEnabled } from "../utils/feature-enabled.util";

export class DragDropProvider<T> extends AbstractProvider {

  protected static readonly DEFAULT_ICON_VIEW: IconView<string> = {
    name: 'drag_handle'
  }

  public readonly isEnabled: boolean = true;
  public readonly COLUMN_NAME = 'tbl_drag_col';
  public readonly manager: AurDragDropManager;
  public readonly draggable: boolean = false;
  public readonly dragIconView: IconView<string> = DragDropProvider.DEFAULT_ICON_VIEW;
  public readonly multiple: boolean = false;
  public readonly size: ColumnSize | undefined;

  constructor(private readonly viewContainerRef: ViewContainerRef,
              private tableName: string,
              dragDropCfg?: DragDropConfig) {
    super();
    // здесь заполнить конфиг значениями по умолчанию если такие появятся
    this.manager = dragDropCfg?.manager ?? AurDragDropManager.empty();
    this.multiple = dragDropCfg?.multiple ?? false;
    this.draggable = (new Set(this.manager.draggableSourceNames)).has(tableName);
    this.dragIconView = dragDropCfg?.dragIcon ?? DragDropProvider.DEFAULT_ICON_VIEW;
    this.size = dragDropCfg?.size;
  }

  public addColumn(columns: string[]): DragDropProvider<T> {
    if (this.notHasKey(this.COLUMN_NAME, columns) && this.draggable) {
      columns.unshift(this.COLUMN_NAME);
    }
    return this;
  }

  /**
   * Фабричный метод для создания экземпляра IndexProvider на основе настройки таблицы.
   * Возвращает заглушку-провайдер, если индекс не включён в настройке.
   * @param tableConfig Настройка таблицы.
   * @returns Экземпляр IndexProvider или IndexProviderDummy.
   */
  public static create<T>(viewContainerRef: ViewContainerRef, tableConfig: TableConfig<T>): DragDropProvider<T> {
    if (DragDropProvider.canCreate(tableConfig)) {
      // @ts-ignore
      return new DragDropProvider(viewContainerRef, tableConfig.name ?? 'unknown-table', <DragDropConfig>tableConfig.dragDropCfg);
    }
    return new DragProviderDummy();
  }

  private static canCreate<T>(tableConfig: TableConfig<T>): boolean {
    return isFeatureEnabled(tableConfig?.dragDropCfg);
  }
}


export class DragProviderDummy extends DragDropProvider<any> {
  public override readonly isEnabled = false;

  constructor() {
    // @ts-ignore
    super(undefined, 'dummy-unknown-name');
  }

  public override addColumn(columns: string[]): DragProviderDummy {
    // Операция не выполняется, так как индекс не включён.
    return this;
  }
}
